export class InvGeneralInitEntity{
    store:string;
    countingType:string;
    goodDeft:string;
    parameterizationId:number;
    creationDate:string;
    active:boolean;
    userId:number;
    closeOpen:boolean;
    validacion:string;
    partNumber:string;
    warehouse:string;
    condition:string;
    location:string;
    quantity:number;
    type:string;
    description:string;
    validacionSerial:string;
    validacionPart:string;
    name:string;
    counting:number;
    constructor (){}
}